<h1 class="text-center mt-2">Gestion des contenus pilot-info</h1>
<div>
  <div class="ml-4">
    <button id="btn-add-concession" class="mr-5 btn btn-dark" (click)="onOpenForm(null)">
      <mat-icon>add_circle</mat-icon> Ajouter un contenu
    </button>
  </div>
  <div class="mt-5 mx-4 d-flex align-items-start">

    <mat-form-field class="mr-3">
      <mat-label>Cherchez un contenu</mat-label>
      <input [(ngModel)]="search" matInput (keyup)="applyFilter($event)">
    </mat-form-field>

    <mat-form-field class="view-filter mr-3 w-auto" style="height: 45px">
      <mat-label>Concession</mat-label>
      <mat-select [(ngModel)]="dealership" (selectionChange)="this.onApplyFilters()" appearance="fill">
        <mat-option>
          <input id="select-search-dealership" class="form-control select-input custom-search-input" (click)="$event.stopPropagation()" (keyup)="filterDealership($event)" type="text" placeholder="Recherche">
        </mat-option>
        <mat-option [value]="'all'">Toutes</mat-option>
        <mat-option *ngFor="let dealership of dealershipArray"  [value]="dealership.nom_concession">
          {{dealership.nom_concession}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-slide-toggle class="pt-3" (change)="onToggleVisibleInactive()">Inactifs visibles</mat-slide-toggle>
  </div>
</div>

<div class="example-container mx-4 mt-3">
  <table mat-table [dataSource]="dataSource" [hidden]="dataSource.data.length == 0">
    <ng-container matColumnDef="dealership">
      <th mat-header-cell *matHeaderCellDef style="width: 180px"> Concession </th>
      <td mat-cell *matCellDef="let element"> {{(element.dealership.length>20)? (element.dealership | slice:0:20)+'...':(element.dealership)}} </td>
    </ng-container>

    <ng-container matColumnDef="value">
      <th mat-header-cell *matHeaderCellDef> Valeur </th>
      <td mat-cell *matCellDef="let element"> {{(element.value.length>100)? (element.value | slice:0:100)+'...':(element.value)}} </td>
    </ng-container>

    <ng-container matColumnDef="startAt">
      <th mat-header-cell *matHeaderCellDef style="width: 150px"> Début </th>
      <td mat-cell *matCellDef="let element"> {{element.startAt | date: 'dd/MM/yyyy'}} </td>
    </ng-container>

    <ng-container matColumnDef="endAt">
      <th mat-header-cell *matHeaderCellDef style="width: 150px"> Fin </th>
      <td mat-cell *matCellDef="let element">
        <span *ngIf="element.isActive" style="color: green;">{{element.endAt ? (element.endAt | date: 'dd/MM/yyyy') : '-'}}</span>
        <span *ngIf="!element.isActive" style="color: red;">{{element.endAt ? (element.endAt | date: 'dd/MM/yyyy') : '-'}}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="brand">
      <th mat-header-cell *matHeaderCellDef style="min-width: 90px"> Marque </th>
      <td mat-cell *matCellDef="let element"> {{element.brand}} </td>
    </ng-container>

    <ng-container matColumnDef="url">
      <th mat-header-cell *matHeaderCellDef style="width: 250px"> URL </th>
      <td mat-cell *matCellDef="let element"> {{getUrlValue(element.publicId)}} </td>
    </ng-container>

    <ng-container matColumnDef="copy">
      <th mat-header-cell *matHeaderCellDef style="width: 80px"> Copier </th>
      <td mat-cell *matCellDef="let element">
        <button class="btn btn" (click)="copyToClipboard(element.publicId)" [disabled]="!element.isActive">
          <mat-icon>file_copy</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="stop">
      <th mat-header-cell *matHeaderCellDef style="width: 50px"> Stop </th>
      <td mat-cell *matCellDef="let element">
        <button [disabled]="!element.isActive" (click)="onStopContent(element.id)" class="m-2 btn btn-round-40 btn-dark">
          <mat-icon>stop</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="edit">
      <th mat-header-cell *matHeaderCellDef style="width: 50px"> Modifier </th>
      <td mat-cell *matCellDef="let element">
        <button (click)="onOpenForm(element.id)" class="m-2 btn btn-round-40 btn-dark">
          <mat-icon>edit</mat-icon>
        </button>
      </td>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  <div *ngIf="dataSource.data.length === 0" style="display: flex;justify-content: center;padding: 25px; align-items: center">
    <span class="material-icons" style="padding: 5px">error</span> Aucun résultat trouvé.
  </div>
  <mat-paginator [hidden]="dataSource.data.length == 0" [pageSizeOptions]="getPageSizeOptions()" (click)="displayPaginatorAllOption()" (page)="pageChange()" showFirstLastButtons aria-label="Sélectionner la page"></mat-paginator>
</div>

